var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-container',{staticClass:"container"},[_c('el-aside',{attrs:{"width":"100%"}},[_c('h2',[_vm._v(_vm._s(_vm.routeTitle.substring(0, _vm.routeTitle.length - 2))+"分类")]),_vm._v(" "),_c('el-tree',{attrs:{"accordion":"","node-key":"catid","data":_vm.navlist,"props":_vm.defaultProps},on:{"node-click":_vm.handleNodeClick},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var node = ref.node;
var data = ref.data;
return _c('span',{staticClass:"custom-tree-node"},[_c('span',{attrs:{"title":node.label}},[_vm._v(_vm._s(node.label))])])}}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e56bc92e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar.vue
// module id = null
// module chunks = 